import { render, staticRenderFns } from "./TrafficAllocation.vue?vue&type=template&id=cbcfd1ca&scoped=true"
import script from "./TrafficAllocation.vue?vue&type=script&lang=js"
export * from "./TrafficAllocation.vue?vue&type=script&lang=js"
import style0 from "./TrafficAllocation.vue?vue&type=style&index=0&id=cbcfd1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcfd1ca",
  null
  
)

export default component.exports